<div pageContent class="store-detail-page-container container" fxFlexFill fxLayout="column" fxLayoutAlign="start center">
  <!-- Hidden PDF Components -->
  <div style="position: absolute; left: -9999px; top: -9999px;" class="pdf-first-page-wrapper"
  >
    <mtn-store-detail-pdf-first-page
      #pdfFirstPage
      [store]="store"
      [additionalInsights]="additionalInsights">
    </mtn-store-detail-pdf-first-page>
  </div>
  <div style="position: absolute; left: -9999px; top: -9999px;" class="pdf-dynamic-page-wrapper">
    <mtn-store-detail-dynamic-page #pdfDynamicPage>
    </mtn-store-detail-dynamic-page>
  </div>
 <div style="position: absolute; left: -9999px; top: -9999px;" class="pdf-middle-page-wrapper"
  >
    <mtn-store-detail-middle-page
      #pdfMiddlePage
      [store]="store"
      [additionalInsights]="additionalInsights">
    </mtn-store-detail-middle-page>
  </div>



  <div style="position: absolute; left: -9999px; top: -9999px;" class="pdf-second-page-wrapper">
    <mtn-store-detail-pdf-second-page
      #pdfSecondPage
      [store]="store"
      [additionalInsights]="additionalInsights">
    </mtn-store-detail-pdf-second-page>
  </div>
   
  <mtn-store-header-panel></mtn-store-header-panel>
  <!-- Comprehensive Ranking View -->
  <div class="Comprehensive-container" *ngIf="showComprehensiveRanking && store">
    <mtn-comprehensive-ranking-table-page></mtn-comprehensive-ranking-table-page>
  </div>

  <!-- Regular Store Detail View -->
  <div id="store-detail-content" class="page-container container" *ngIf="!showComprehensiveRanking && store && (!hasLicense(LicenseType.STANDARD) || isMarketAreaLoaded)"
       fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="50px">
    <div fxLayout="row" fxLayoutGap="30px">
      <div fxFlex>
        <mtn-store-alerts-panel #alertsPanel [hidden]="!alertsPanel.alertsCount"></mtn-store-alerts-panel>
      </div>
      <div class="actions-toolbar">
        <!-- <button mat-raised-button class="pdf-preview-button" (click)="previewPdf()"
                matTooltip="Preview PDF Report"
                mtnAnalyticsEventTrigger
                [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                [analyticsEventParameters]="{'target': 'preview-pdf-button'}">
          <fa-icon icon="eye"></fa-icon>
          Preview PDF
        </button> -->
        <button mat-raised-button class="pdf-download-button" (click)="downloadPdf()"
                [disabled]="!isPdfDataReady" *ngIf="((hasInternalLicense || hasStandardLicense) && (store.currentStatus.type.systemName==='OPEN' || store.currentStatus.type.systemName=== 'TEMPORARILY_CLOSED' || store.currentStatus.type.systemName==='REMODEL'))"
                matTooltip="Download PDF Report"
                mtnAnalyticsEventTrigger
                [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                [analyticsEventParameters]="{'target': 'download-pdf-button'}">
          <fa-icon icon="file-pdf"></fa-icon>
          Download PDF
        </button>
        <mtn-store-actions-menu-button [storeUuids]="[store.uuid]" mtnAnalyticsEventTrigger
                                       [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                                       [analyticsEventParameters]="{'target': 'store-details-actions-menu-button'}"></mtn-store-actions-menu-button>
      </div>
    </div>
    <mtn-store-critical-insights-panel #criticalInsightsPanel (uiReady)="onCriticalInsightsReady()"></mtn-store-critical-insights-panel>
    <mtn-store-sales-performance-panel (showComprehensiveRanking)="onShowComprehensiveRanking()" (keyIndicatorChanged)="updateSelectedKeyIndicator($event)" (rankingFiltersForPdf)="updateCurrentRankingFilters($event)" (rankingDataForPdf)="updateCurrentRankingData($event)"></mtn-store-sales-performance-panel>
    <mtn-store-additional-insights-panel></mtn-store-additional-insights-panel>
    <mtn-store-demographic-profile-panel></mtn-store-demographic-profile-panel>
    <!-- <mtn-store-competitive-analysis-panel></mtn-store-competitive-analysis-panel> -->
    <mtn-store-banner-analysis-panel></mtn-store-banner-analysis-panel>
    <mtn-footer></mtn-footer>
  </div>
  <mtn-spinner [isPageSpinner]="true"
               [on]="!showComprehensiveRanking && (!store || (hasLicense(LicenseType.STANDARD) && !isMarketAreaLoaded))"></mtn-spinner>


</div>
